import sa from "superagent";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import CurrentUserStore from "../../stores/CurrentUserStore";
import MembershipDetailsForCurrentUserStore from "../../stores/MembershipDetailsForCurrentUserStore";

export const AmplifyDashboard = ({ url, config = Map() }) => {
  const [districts, setDistricts] = useState(null);
  const [error, setError] = useState(null);
  const [availableDistricts, setAvailableDistricts] = useState([])

  const key = config.get("key");
  useEffect(() => {
    // TODO: should i actually do something with url?
    const req = sa
      .post("https://bigal.media/dashboard/dashboarddistrictdata.php")
      .send(`SecurityKey=${key}`)
      .then(({ body }) => {
        setDistricts(body.Data);
      })
      .catch((err) => {
        console.log(`Error while fetching districts ${err}`);
        setError("Unable to fetch districts from Amplify");
      });
    return () => { };
  }, [url, key]);

  useEffect(() => {
    if (districts) {
      const currentUserOrgIds = MembershipDetailsForCurrentUserStore.getState()
        .map(({ organization }) => organization.id)
        .toSet();
      setAvailableDistricts(!config.get("filter", null)
        ? districts
        : districts.filter((district) => {
          const [districtKey] = district["DistrictCode"].split(" ");
          const filterSetting = config.getIn(["filter", districtKey], null);
          // If filter is provided for this district, require match. Otherwise, allow.
          if (filterSetting) {
            return filterSetting.find((searchOrgId) =>
              currentUserOrgIds.has(searchOrgId)
            );
          } else {
            console.info(`No filter setting for ${districtKey}`);
            return true;
          }
        }));
    }
  }, [districts])

  useEffect(() => {
    if (availableDistricts.length != 0) {
      selectDistrict(availableDistricts[0]["DistrictID"]);
    }
  }, [availableDistricts])

  const formRef = useRef();

  const selectDistrict = (districtID) => {
    if (districtID) {
      formRef.current.action = `https://bigal.media/dashboard/dashboardframe.php?DistrictID=${districtID}`;
      formRef.current.submit();
    }
  };

  if (error) {
    return <p>{error}</p>;
  } else if (districts) {
    const currentUser = CurrentUserStore.getState();
    return (
      <div style={{ height: "75%" }}>
        <div className="contentPicker">
          <form target="amplify-iframe" method="post" action="" ref={formRef}>
            <input type="hidden" name="SecurityKey" value={key} />
            <input
              type="hidden"
              name="DashboardUserID"
              value={currentUser ? currentUser.email : ""}
            />
            <FormGroup controlId="">
              <ControlLabel>District:</ControlLabel>
              <FormControl
                componentClass="select"
                placeholder="select"
                onChange={(e) => selectDistrict(e.target.value)}
              >
                {availableDistricts.map((district) => (
                  <option
                    key={district["DistrictID"]}
                    value={district["DistrictID"]}
                  >
                    {district["DistrictCode"]}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </form>
        </div>
        <iframe
          src=""
          id="amplify-iframe"
          name="amplify-iframe"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    );
  } else {
    return <p>Loading...</p>;
  }
};

AmplifyDashboard.propTypes = {
  url: PropTypes.string,
  config: ImmutablePropTypes.map,
};

export default AmplifyDashboard;
